<template>
  <div
    v-if="widgetId"
    class="etrusted-widget"
  >
    <div class="etrusted-widget__wrapper">
      <etrusted-widget
        class="etrusted-widget__widget"
        :data-etrusted-widget-id="widgetId"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
// declare global {
//   interface Window {

//   }
// }

const props = defineProps<{
  widgetId?: string
}>()

const scriptId = 'etrusted-widget'
const { initiatedThirdParty } = useApp()

watch(initiatedThirdParty, () => {
  initScript()
})

function initScript() {
  if (!initiatedThirdParty.value) {
    return
  }

  if (!document?.getElementById(scriptId) && props.widgetId) {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.id = scriptId

    script.src = `https://integrations.etrusted.com/applications/widget.js/v2`

    document.body.appendChild(script)
  }
}

onMounted(() => {
  initScript()
})

// onUnmounted(() => {
// })
</script>

<style>
@import url("~layers/app/components/Thirdparty/EtrustedBadge.css");
</style>
